/* Premier Catering Supplies — "Build a matching table" colour picker (26-9-2026).
   Switching colour rewrites each card's title, tint and search link, then checks live counts
   (search view pch-count) and hides any card with no products in that colour. */
(function () {
  'use strict';
  document.querySelectorAll('[data-pcm]').forEach(function (root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-pcm-config]').textContent); } catch (e) { return; }
    var base = root.getAttribute('data-search') || '/search';
    var sws = [].slice.call(root.querySelectorAll('.pcm-sw'));
    var cards = [].slice.call(root.querySelectorAll('.pcm-card'));
    var empty = root.querySelector('.pcm__empty');
    var cache = {};
    var token = 0;

    function orList(prefix, list, quote) {
      return list.map(function (s) { s = s.trim(); return prefix + (quote ? '"' + s + '"' : s); }).filter(function (s) { return s.length > prefix.length; }).join(' OR ');
    }
    function query(itemIdx, colour) {
      var tags = orList('tag:', String(cfg.items[itemIdx] || '').split('|'), true);
      var words = orList('title:', String(colour.words || '').split(','), false);
      return '(' + tags + ') AND (' + words + ')';
    }
    function count(q) {
      if (cache[q] === undefined) {
        cache[q] = fetch(base + '?view=pch-count&type=product&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (d) { return +d.count || 0; })
          .catch(function () { delete cache[q]; return -1; }); /* -1 = unknown → keep card visible */
      }
      return cache[q];
    }
    function apply(i, check) {
      var colour = cfg.colours[i];
      if (!colour) return;
      var my = ++token;
      sws.forEach(function (b, j) { var on = j === i; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      cards.forEach(function (card) {
        var idx = +card.getAttribute('data-item');
        var q = query(idx, colour);
        card.style.setProperty('--mc', colour.swatch);
        card.querySelector('[data-cl]').textContent = colour.label;
        card.querySelector('a').href = base + '?type=product&q=' + encodeURIComponent(q);
      });
      if (!check) return;
      root.classList.add('is-checking');
      Promise.all(cards.map(function (card) { return count(query(+card.getAttribute('data-item'), colour)); })).then(function (ns) {
        if (my !== token) return;
        var shown = 0;
        cards.forEach(function (card, k) { var hide = ns[k] === 0; card.hidden = hide; if (!hide) shown++; });
        empty.hidden = shown > 0;
        root.classList.remove('is-checking');
      });
    }

    sws.forEach(function (b, i) {
      b.tabIndex = b.classList.contains('is-on') ? 0 : -1;
      b.addEventListener('click', function () { apply(i, true); });
      b.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        var n = (i + d + sws.length) % sws.length;
        sws[n].focus();
        apply(n, true);
      });
    });
    var start = sws.findIndex ? sws.findIndex(function (b) { return b.classList.contains('is-on'); }) : 0;
    apply(start < 0 ? 0 : start, true);
    /* warm the cache for every colour the first time a shopper reaches for the swatches, so switching is instant */
    var warmed = false;
    var warm = function () { if (warmed) return; warmed = true; cfg.colours.forEach(function (c) { cards.forEach(function (card) { count(query(+card.getAttribute('data-item'), c)); }); }); };
    var group = root.querySelector('.pcm__swatches');
    group.addEventListener('pointerenter', warm);
    group.addEventListener('focusin', warm);
    group.addEventListener('touchstart', warm, { passive: true });
  });
})();